<template>
    <div id="listContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>


        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @cellDblClick="cellDblClick"
        >
            <template v-slot:operate>
                <!-- 导出各发票类型都能用（红字也要导出）；开票、替换、修改只在正式发票下显示 -->
                <template v-if="queryForm.formData.invoice_type == 1">
                <a-button 
                    v-permission="'setting.invoice.create2CInvoice'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('create2CInvoice')"
                ><icon-plus-circle style="margin-right:5px" />{{ $t('invoice.create2CInvoice') }}</a-button>
                <a-divider v-permission="'setting.invoice.create2CInvoice'" direction="vertical" />
                <a-button 
                    v-permission="'setting.invoice.create2BInvoice'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('create2BInvoice')"
                ><icon-plus-circle  style="margin-right:5px" />{{ $t('invoice.create2BInvoice') }}</a-button>
                <a-divider v-permission="'setting.invoice.exportInvoice'" direction="vertical"  />
                </template>
                <a-button 
                    v-permission="'setting.invoice.exportInvoice'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('exportInvoice')"
                ><icon-export  style="margin-right:5px" />{{ $t('invoice.exportInvoice') }}</a-button>
                <template v-if="queryForm.formData.invoice_type == 1">
                <a-divider v-permission="'setting.invoice.replaceInvoice'" direction="vertical" />
                <a-button 
                    v-permission="'setting.invoice.replaceInvoice'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('replaceInvoice')"
                ><icon-upload  style="margin-right:5px" />{{ $t('invoice.replaceInvoice') }}</a-button>
                <a-divider v-permission="'setting.invoice.modifyInvoice'" direction="vertical" />
                <a-button 
                    v-permission="'setting.invoice.modifyInvoice'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('modifyInvoice')"
                ><icon-edit  style="margin-right:5px" />{{ $t('invoice.modifyInvoice') }}</a-button>
                </template>
            </template>

            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'invoice_no'">
                    <div>{{ props.record.invoice_no }}</div>
                    <!-- 失效发票的订单有有效平台票时，带出平台票号 -->
                    <div v-if="props.record.platform_invoice_no" class="platform_no">{{ $t('invoice.platformNo') }}: {{ props.record.platform_invoice_no }}</div>
                </div>
                <div v-if="props.column.key == 'order_channel_type'">
                    <!-- 没有关联订单的发票（退款与红字导入 Order Check 为 No）不显示订单类型 -->
                    <span v-if="props.record.order_channel_type_val == null">-</span>
                    <a-tooltip :content="props.record.payment" v-else-if="props.record.order_channel_type_val == 1">
                        <a-tag :color="props.record.order_channel_type_val == 0? 'blue' : 'green' " style="cursor:pointer">{{ props.record.order_channel_type }}</a-tag>
                    </a-tooltip>
                    <a-tag v-else :color="props.record.order_channel_type_val == 0? 'blue' : props.record.order_channel_type_val == 1? 'green' : props.record.order_channel_type_val == 4? 'pinkpurple' : 'cyan' ">{{ props.record.order_channel_type }}</a-tag>
                </div>
                <div v-if="props.column.key == 'invoice_type'">
                    <a-tag :color="props.record.invoice_type_val == 1? 'blue' : props.record.invoice_type_val == 2? 'red' : 'gold' ">{{ props.record.invoice_type }}</a-tag>
                </div>
                <div v-if="props.column.key == 'invoiceVaildStatus'">
                    <a-tag :color="props.record.invoiceVaildStatus_val == 0? 'green' : 'red' ">{{ props.record.invoiceVaildStatus }}</a-tag>
                </div>
                <div v-if="props.column.key == 'pay_status'">
                    <a-tag v-if="props.record.pay_status != '-'" :color="payStatusColor[props.record.pay_status_val]">{{ props.record.pay_status }}</a-tag>
                    <span v-else>-</span>
                </div>
                <div v-if="props.column.key == 'order_name'">
                    <a-popover position="top" trigger="click" @popup-visible-change="(val)=>popupVisibleChangeAmount(val,props.record)">
                        <a-button type="text" style="text-wrap: wrap;">{{ props.record.order_name }}</a-button>
                        <template #content>
                            <a-spin :loading="amountInfo_loading" tip="loading..." class="customer_info">
                                <div><span style="font-weight:bold">{{ $t('invoice.orderName') }}：</span> {{ props.record.order_name }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.customerName') }}：</span> {{ customerInfo.name }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.customerName2') }}：</span> {{ customerInfo.name2 }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.customerPhone') }}：</span> {{ customerInfo.phone }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.zip') }}：</span> {{ customerInfo.zip }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.customerCity') }}：</span> {{ customerInfo.city }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.customerAddr') }}：</span> {{ customerInfo.address }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.customerAddr2') }}：</span> {{ customerInfo.address2 }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.billingAddress') }}：</span> {{ customerInfo.billing_address }}</div>
                                <div><span style="font-weight:bold">{{ $t('customer.customerEmail') }}：</span> {{ customerInfo.email }}</div>
                            </a-spin>
                        </template>
                    </a-popover>
                </div>
                <div v-if="props.column.key == 'amount'">
                    <div style="display:flex;font-size:12px" v-if="props.record.invoice_amount != '-'">
                        <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('invoice.invoiceAmount') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.invoice_amount }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:tableOperate="{ props }">
                    <a-button 
                        v-permission="'setting.invoice.downloadInvoice'" 
                        type="primary" 
                        size="mini" 
                        :disabled="props.record.invoiceVaildStatus_val == 1 || (queryForm.formData.valid_flag === 0 && !props.record.download_path) || (queryForm.formData.valid_flag === 1 && (props.record.invoice_type_val == 1 ? !props.record.download_path : !props.record.file_no))"
                        style="margin-right:5px"
                        @click="handle('reDownload',props.record)"
                    >
                        <a-tooltip :content="t('invoice.reDownload')">
                            <icon-download size="14" />
                        </a-tooltip>
                        <!-- {{ $t('invoice.reDownload') }} -->
                    </a-button>
                    <!-- <a-divider v-permission="'setting.invoice.reGenerateInvoice'" direction="vertical" /> -->
                    <!-- style="margin-top:5px;width:92px"  -->
                    <a-button 
                        v-permission="'setting.invoice.reGenerateInvoice'"  
                        type="primary" 
                        size="mini" 
                        :disabled="props.record.invoice_type_val == 2 || queryForm.formData.valid_flag === 1 || (queryForm.formData.valid_flag === 0 && !props.record.download_path) || (props.record.invoice_type_val == 1 && props.record.order_channel_type_val == 1 && props.record.invoice_child_type == '-')" 
                        style="margin-right:5px"
                        @click="handle('reGenerate',props.record)"
                    >
                        <a-tooltip :content="t('invoice.reGenerate')">
                            <icon-loop size="14" />
                        </a-tooltip>
                        <!-- {{ $t('invoice.reGenerate') }} -->
                    </a-button>
                    <!-- <a-divider v-permission="'setting.invoice.sendInvoice'" direction="vertical" /> -->
                    <a-button 
                        v-permission="'setting.invoice.sendInvoice'"  
                        type="primary" 
                        :status="props.record.send_sequence == 0? 'normal' : 'warning'" 
                        size="mini" 
                        :disabled="props.record.invoice_type_val == 2 || (queryForm.formData.valid_flag === 0 && !props.record.download_path) || props.record.sendBtnText == $t('invoice.sending') || queryForm.formData.valid_flag === 1" 
                        style="margin-right:5px"
                        @click="handle('send',props.record)"
                    >
                        <a-tooltip :content="props.record.sendBtnText">
                            <icon-send size="14" />
                        </a-tooltip>
                        <!-- {{ props.record.sendBtnText }} -->
                    </a-button>
                    <a-button 
                        v-permission="'setting.invoice.invalidInvoice'" 
                        type="primary" status="warning" 
                        size="mini" 
                        :disabled="props.record.invoice_type_val == 2 || props.record.invoiceVaildStatus_val == 1" 
                        @click="handle('invalid',props.record)"
                    >
                        <a-tooltip :content="t('invoice.invalidate')">
                            <icon-close-circle size="14" />
                        </a-tooltip>
                    </a-button>
                    <!-- <a-divider v-permission="'setting.invoice.sendInvoice'" direction="vertical" /> -->
                    <a-button 
                        v-permission="'setting.invoice.deleteInvoice'" 
                        type="primary" status="danger" 
                        size="mini" 
                        :disabled="props.record.invoice_type_val == 2" 
                        @click="handle('delete',props.record)"
                    >
                        <a-tooltip :content="t('invoice.delete')">
                            <icon-delete size="14" />
                        </a-tooltip>
                        <!-- {{ $t('invoice.delete') }} -->
                    </a-button>   
            </template>
        </Table>

        <!-- 创建To C发票 -->
        <a-modal
            v-model:visible="visible2C" 
            width="85%"
            :title="$t('invoice.create2CInvoice')"
            draggable
            :footer="false"
        >
            <InvoiceOrderList :visible="visible2C"></InvoiceOrderList>
            
        </a-modal>

        <!-- 创建To B发票 -->
        <a-modal
            v-model:visible="visible2B" 
            width="85%"
            :title="$t('invoice.create2BInvoice')"
            draggable
            :footer="false"
        >
            <InvoiceOutboundList v-if="visible2B" :visible="visible2B" :invoiceType="invoice_type"></InvoiceOutboundList>
        </a-modal>

         <!-- 选择发票类型 -->
         <a-modal
            v-model:visible="invoiceTypeVisible" 
            width="700px"
            :title="$t('invoice.selectInvoiceType')"
            draggable
            :onBeforeOk="onSelectInvoiceTypeBeforeOk"
        >
            <a-radio-group v-model="invoice_type">
                <a-radio value="1">{{ $t('invoice.normalInvoice') }}</a-radio>
                <a-radio value="2">{{ $t('invoice.prepaidInvoice') }}</a-radio>
            </a-radio-group>
        </a-modal>

        <!-- 重新生成To C发票 -->
        <a-modal
            v-model:visible="reGenerateVisible" 
            width="780px"
            :title="$t('invoice.reGenerateInvoice')"
            draggable
            :onBeforeOk="onreGenerateBeforeOk"
        >
            <a-alert style="margin-bottom:15px;width:730px;font-size:12px;font-weight:600;">
                <div>1. {{ $t('invoice.downloadInvoiceTip') }}</div>
                <div>2. {{ $t('order.invoiceDateTip') }}</div>
            </a-alert>
            <span>{{ $t('base.date') }}：</span>
            <a-date-picker
                style="width: 280px; margin: 0 24px 24px 0;"
                :model-value="invoice_date"
                format="YYYY-MM-DD"
                @change="changeInvoiceDate"
            />
        </a-modal>


        <!-- 批量替换发票附件 -->
        <a-modal
            v-model:visible="replaceVisible"
            width="900px"
            :title="$t('invoice.replaceInvoice')"
            draggable
            :footer="false"
            :mask-closable="false"
            @close="resetReplace"
        >
            <a-alert style="margin-bottom:15px;font-size:12px;">
                <div>1. {{ $t('invoice.replaceTip1') }}</div>
                <div>2. {{ $t('invoice.replaceTip2') }}</div>
                <div>3. {{ $t('invoice.replaceTip3') }}</div>
            </a-alert>

            <a-upload
                :file-list="replaceFileList"
                accept=".pdf"
                action=""
                multiple
                :auto-upload="false"
                :show-file-list="true"
                :show-retry-button="false"
                @change="replaceUploadChange"
            />

            <div style="margin-top:15px">
                <a-button
                    type="outline"
                    :loading="replaceLoading"
                    :disabled="replaceFileList.length == 0"
                    @click="submitReplace(true)"
                >
                    <icon-search size="14" style="margin-right:5px" />{{ $t('invoice.replaceDryRun') }}
                </a-button>
                <a-button
                    type="primary"
                    status="danger"
                    style="margin-left:10px"
                    :loading="replaceLoading"
                    :disabled="replaceFileList.length == 0"
                    @click="confirmReplace"
                >
                    <icon-upload size="14" style="margin-right:5px" />{{ $t('invoice.replaceConfirm') }}
                </a-button>
            </div>

            <div v-if="replaceResult.length" style="margin-top:15px">
                <div style="font-weight:600;margin-bottom:8px">{{ $t('invoice.replaceResult') }}</div>
                <a-table
                    :data="replaceResult"
                    :pagination="false"
                    :scroll="{ y: 260 }"
                    size="mini"
                    row-key="file_name"
                >
                    <template #columns>
                        <a-table-column :title="$t('invoice.replaceFileName')" data-index="file_name" :width="200" />
                        <a-table-column :title="$t('invoice.invoiceNo')" data-index="invoice_no" :width="130" />
                        <a-table-column :title="$t('invoice.replaceStatus')" :width="110">
                            <template #cell="{ record }">
                                <a-tag :color="replaceStatusColor[record.status]">{{ record.status }}</a-tag>
                            </template>
                        </a-table-column>
                        <a-table-column :title="$t('invoice.replaceMessage')" data-index="message" />
                    </template>
                </a-table>
            </div>
        </a-modal>

        <!-- 批量修改发票 -->
        <a-modal
            v-model:visible="modifyVisible"
            width="960px"
            :title="$t('invoice.modifyInvoice')"
            draggable
            :footer="false"
            :mask-closable="false"
            @close="resetModify"
        >
            <a-alert style="margin-bottom:15px;font-size:12px;">
                <div>1. {{ $t('invoice.modifyTip1') }}</div>
                <div>2. {{ $t('invoice.modifyTip2') }}</div>
                <div>3. {{ $t('invoice.modifyTip3') }}</div>
            </a-alert>

            <a-upload
                :file-list="modifyFileList"
                accept=".xlsx,.xls"
                action=""
                :limit="1"
                :auto-upload="false"
                :show-file-list="true"
                :show-retry-button="false"
                @change="modifyUploadChange"
            />

            <div style="margin-top:15px">
                <a-button
                    type="outline"
                    :loading="modifyLoading"
                    :disabled="modifyFileList.length == 0"
                    @click="submitModify(true)"
                >
                    <icon-search size="14" style="margin-right:5px" />{{ $t('invoice.modifyDryRun') }}
                </a-button>
                <a-button
                    type="primary"
                    status="danger"
                    style="margin-left:10px"
                    :loading="modifyLoading"
                    :disabled="modifyFileList.length == 0"
                    @click="confirmModify"
                >
                    <icon-edit size="14" style="margin-right:5px" />{{ $t('invoice.modifyConfirm') }}
                </a-button>
                <a-button
                    style="margin-left:10px"
                    :loading="modifyChecking"
                    :disabled="modifyFileList.length == 0"
                    @click="exportModifyCheck"
                >
                    <icon-download size="14" style="margin-right:5px" />{{ $t('invoice.modifyCheckExport') }}
                </a-button>
                <a-button
                    style="margin-left:10px"
                    :loading="modifyExporting"
                    :disabled="modifyResult.length == 0"
                    @click="exportModifyResult"
                >
                    <icon-export size="14" style="margin-right:5px" />{{ $t('invoice.modifyChangeExport') }}
                </a-button>
            </div>

            <div v-if="modifyResult.length" style="margin-top:15px">
                <div style="font-weight:600;margin-bottom:8px">{{ $t('invoice.modifyResult') }}</div>
                <a-table
                    :data="modifyResult"
                    :pagination="false"
                    :scroll="{ y: 300 }"
                    size="mini"
                    row-key="row_num"
                >
                    <template #columns>
                        <a-table-column title="#" data-index="row_num" :width="60" />
                        <a-table-column :title="$t('invoice.invoiceNo')" data-index="invoice_no" :width="130" />
                        <a-table-column :title="$t('invoice.replaceStatus')" :width="110">
                            <template #cell="{ record }">
                                <a-tag :color="replaceStatusColor[record.status]">{{ record.status }}</a-tag>
                            </template>
                        </a-table-column>
                        <a-table-column :title="$t('invoice.modifyAction')" :width="120">
                            <template #cell="{ record }">
                                <a-tag v-if="record.action == 'RESTORE'" color="purple">{{ $t('invoice.modifyActionRestore') }}</a-tag>
                                <span v-else-if="record.action">{{ $t('invoice.modifyActionModify') }}</span>
                                <span v-else>-</span>
                            </template>
                        </a-table-column>
                        <a-table-column :title="$t('invoice.modifyChange')" :width="300">
                            <template #cell="{ record }">
                                <span style="font-size:12px">{{ changeSummary(record) }}</span>
                            </template>
                        </a-table-column>
                        <a-table-column :title="$t('invoice.replaceMessage')" data-index="message" />
                    </template>
                </a-table>
            </div>
        </a-modal>

        <!-- 录入付款金额 -->
        <a-modal
            v-model:visible="payAmountVisible" 
            width="600px"
            :title="$t('invoice.payAmount')"
            draggable
            :render-to-body="false"
            :onBeforeOk="onBeforeOkPayAmount"
        >
            <a-alert class="countBar">
                <span>{{ $t('invoice.payAmountTip') }}</span>
            </a-alert>
            <div>
                <a-input-number 
                    :style="{width:'320px', marginBottom:'10px'}" 
                    v-model="payAmount" 
                    allow-clear 
                    hide-button 
                    placeholder="Please Enter"  
                    :min="0"
                    :max="maxAmount"
                />
            </div>
            <div>
                <a-date-picker v-model="payment_date" :allow-clear="false" style="width: 320px;" />
            </div>
            
        </a-modal>

    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick } from 'vue';
    import { useRouter, useRoute } from 'vue-router';
    import { InvoiceApi } from '@/api/InvoiceApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { PrepaidOrderApi } from '@/api/PrepaidOrderApi.js'; 
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import InvoiceOrderList from './InvoiceOrderList.vue';
    import InvoiceOutboundList from './InvoiceOutboundList.vue';
    import { InvoiceListQuery } from './queryConfig/InvoiceListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate, getNowDate, hasPermission } from '@/utils/index.js';

    const { t } = useI18n()
    const localeStore = useLocale()
    const router = useRouter()
    const route = useRoute()

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const visible2C = ref(false)
    const visible2B = ref(false)
    const payAmountVisible = ref(false)
    const reGenerateVisible = ref(false)
    const replaceVisible = ref(false)
    const replaceFileList = ref([])
    const replaceResult = ref([])
    const replaceLoading = ref(false)
    const replaceStatusColor = {
        SUCCESS:'green',
        DRY_RUN:'blue',
        SKIPPED:'orange',
        FAILED:'red',
    }
    const modifyVisible = ref(false)
    const modifyFileList = ref([])
    const modifyResult = ref([])
    const modifyLoading = ref(false)
    const modifyExporting = ref(false)
    const modifyChecking = ref(false)
    const showForm = ref(false)
    const rowData = ref({})
    const invoice_date = ref('')
    const customerInfo = ref({})
    const customerInfo_loading = ref(false)
    const sending = ref(false)
    const queryForm = reactive(InvoiceListQuery)
    const payAmount = ref('')
    const payment_date = ref('')
    const invoiceTypeVisible = ref(false)
    const invoice_type = ref('1')
    const is_hepha_customer = ref(false)
    // 付款金额编辑权限。原先只在 editPayAmount 里用 role.indexOf('1')/('4') 判断，
    // 而 userInfo.role 是角色 ID 逗号拼成的字符串，"18"(all_query) 会被 indexOf('1') 命中，
    // 等于所有 ID 里带 1 或 4 的角色都放行了。改成按钮权限位。
    const canEditPayAmount = ref(hasPermission('setting.invoice.editPayAmount'))
    const maxAmount = ref(9999999)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
                fixed:'left',
            },
            {
                // title: '发票号',
                title: t('invoice.invoiceNo'),
                dataIndex: 'invoice_no',
                key:'invoice_no',
                width:'120',
                fixed:'left',
                slotName:'slot',
            },
            {
                // title: '订单号',
                title: t('invoice.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'140',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '出库单号',
                title: t('invoice.invoiceChildType'),
                dataIndex: 'invoice_child_type',
                key:'invoice_child_type',
                width:'160',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单类型',
                title: t('order.orderChannelType'),
                dataIndex: 'order_channel_type',
                key:'order_channel_type',
                width:'180',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '发票类型',
                title: t('invoice.invoiceType'),
                dataIndex: 'invoice_type',
                key:'invoice_type',
                width:'180',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '发票状态',
                title: t('invoice.invoiceVaildStatus'),
                dataIndex: 'invoiceVaildStatus',
                key:'invoiceVaildStatus',
                width:'160',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '付款状态',
                title: t('invoice.payStatus'),
                dataIndex: 'pay_status',
                key:'pay_status',
                width:'150',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '发票金额',
                title: t('invoice.amount'),
                dataIndex: 'amount',
                key:'amount',
                width:'140',
                ellipsis:true,
                tooltip:true,
                slotName:'slot',
            },
            {
                // title: '创建时间',
                title: t('invoice.createDate'),
                dataIndex: 'create_timestamp',
                key:'create_timestamp',
                width:'120',
                ellipsis:true,
                tooltip:true,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'220',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1200,
                y:540,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const payStatusText = reactive({
        0:t('order.partialPay'),
        1:t('order.pay'),
        7:t('order.obligation'),
    })
    const payStatusColor = reactive({
        0:'orange',
        1:'green',
        7:'red',
    })

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getInvoiceList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    if(item.key !== 'invoice_type' && item.key !== 'valid_flag'){
                        queryForm.formData[item.key] = ''
                    }
                })
                table.value.configs.pagination.current = 1
                // queryForm.formData.valid_flag = 0
                // queryForm.formData.invoice_type = 1
                getInvoiceList()
                break;
            case 'create2CInvoice':
                visible2C.value = true
                break;
            case 'create2BInvoice':
                visible2B.value = true
                // invoice_type.value = ''
                // invoiceTypeVisible.value = true
                break;
            case 'replaceInvoice':
                resetReplace()
                replaceVisible.value = true
                break;
            case 'modifyInvoice':
                resetModify()
                modifyVisible.value = true
                break;
            case 'exportInvoice':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile()
                    }
                });
                break;
            case 'reDownload':
                if(row.invoice_type_val == 2 || (queryForm.formData.valid_flag === 1 && row.invoice_type_val != 1)){ // 红字、作废的预付款发票：按 FILE_NO 直接取文件
                    downloadInvaildInvoice(row)
                }else if(row.order_channel_type_val === 0){ // user；有效、作废的普通发票都按发票 ID 取已有文件，不开新票
                    downloadToCInvoice(row)
                }else{ // dealer
                    downloadToBInvoice(row)
                }
                break;
            case 'reGenerate':
                reGenerateVisible.value = true
                validIsExistInvoice(row)
                rowData.value = row
                break;
            case 'send':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content:  t('invoice.sendInvoiceMsg'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        sendInvoice(row)
                    }
                })
                break;
            case 'delete':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content:  t('invoice.deleteMsg', { no: row.invoice_no }),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        deleteInvoice(row)
                    }
                })
                break;
            case 'invalid':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content:  t('invoice.invalidateMsg', { no: row.invoice_no }),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        invalidInvoice(row)
                    }
                })
                break;
        }
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getInvoiceList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getInvoiceList()
    }

    const handleSelectChange = (val,opt,key)=>{
        if(key == 'invoice_type'){
            queryForm.formField.forEach(i=>{
                if(i.key !== 'invoice_type' && i.key !== 'valid_flag'){
                    queryForm.formData[i.key] = ''
                }
            })
        }
        table.value.configs.pagination.current = 1
        getInvoiceList()
    }

    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getInvoiceList()
    }

    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getInvoiceList()
    }

    const handlePickerDateChange = (val,item)=>{
        table.value.configs.pagination.current = 1
        if(item.key == 'create_timestamp'){
            queryForm.formData.begin_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.end_date = !val? '' : dateToTimestamp(val[1])
        }

        getInvoiceList()
    }

    const popupVisibleChangeAmount = (val,row)=>{
        if(val) getCustomerInfo(row)
    }

    // 编辑支付金额
    const editPayAmount = (row)=>{
        if(!canEditPayAmount.value || is_hepha_customer.value) {
            return
        }
        maxAmount.value = Number(row.invoice_amount.split(' ')[1])
        payAmountVisible.value = true
        payAmount.value = row.real_pay_amount == '-'? '' : Number(row.real_pay_amount.split(' ')[1])
        payment_date.value = row.payment_timestamp == ''? '' : row.payment_timestamp
        rowData.value = row
    }

    // 选择发票类型
    const onSelectInvoiceTypeBeforeOk = ()=>{
        if(invoice_type.value == ''){
            Message.error(t('invoice.selectInvoiceTypeTip'))
            return false
        }
        visible2B.value = true

        return true
    }

    // 自定义发票日期
    const changeInvoiceDate = (dateString, date)=>{
        // console.log(dateString, date,'dateString, date')
        invoice_date.value = dateString
    }

    const onreGenerateBeforeOk = ()=>{
        if(rowData.value.order_channel_type_val == 0){ // user
            reGenerateToCInvoice(rowData.value)
        }else{ // dealer
            reGenerateToBInvoice(rowData.value)
        }
        
        return true
    }

    // 获取发票列表
    const getInvoiceList = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'create_timestamp'){
                form[i.key] = queryForm.formData[i.key]
            }
        })

        let param = {
            ...form,
            order_name:form.order_name.trim(),
            invoice_child_type:form.invoice_child_type.trim(),
            invoice_no:form.invoice_no.trim(),
            begin_date:!queryForm.formData.create_timestamp? '' : dateToTimestamp(`${queryForm.formData.create_timestamp[0]} 00:00:00`),
            end_date:!queryForm.formData.create_timestamp? '' : dateToTimestamp(`${queryForm.formData.create_timestamp[1]} 23:59:59`),
            // valid_flag:0,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await InvoiceApi.getInstance().getInvoiceList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    invoice_child_type: item.invoice_child_type == undefined? '-' : item.invoice_child_type,
                    invoice_amount: item.invoice_amount == undefined? '-' : '€ ' + item.invoice_amount,
                    order_channel_type_val:item.order_channel_type,
                    order_channel_type: item.order_channel_type == null? '-' : item.order_channel_type === 0? t('order.user') : item.order_channel_type === 1? t('order.dealer') : item.order_channel_type === 5? t('order.c2c') : t('order.service'),
                    sendBtnText: item.send_sequence == 0? t('invoice.send') : t('invoice.reSend'),
                    create_timestamp:item.create_timestamp == undefined? '-' : timestampToDate(item.create_timestamp * 1000).split(' ')[0],
                    invoiceVaildStatus_val: item.valid_flag,
                    invoiceVaildStatus: item.valid_flag == 0? t('invoice.vaild') : t('invoice.invaild'),
                    pay_status_val: item.pay_status,
                    pay_status: item.pay_status == undefined? '-' : payStatusText[item.pay_status],
                    real_pay_amount: item.real_pay_amount == undefined? '-' : '€ ' + item.real_pay_amount,
                    invoice_type_val: item.invoice_type,
                    invoice_type: item.invoice_type == '1'? t('invoice.normalInvoice') : item.invoice_type == '2'? t('invoice.creditNote') : t('invoice.prepaidInvoice'),
                    payment: `${t('order.paymentType')}: ${item.payment}`,
                    payment_timestamp: item.payment_timestamp? timestampToDate(item.payment_timestamp * 1000).split(' ')[0] : '',
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 判断发票是否存在
    const validIsExistInvoice = async(row)=>{
        let invoiceChildType = row.invoice_child_type == '-'? '' : row.invoice_child_type
        let res = await InvoiceApi.getInstance().validIsExistInvoice(row.order_id, 1, invoiceChildType)
        if(res.code == 0){
            invoice_date.value = res.data.length == 0? getNowDate() : timestampToDate(res.data[0].create_timestamp * 1000).split(' ')[0]
        }else{
            Message.error(res.msg)
        }
    }

    // 重新下载To C发票
    const downloadToCInvoice = async (row)=>{
        let param = {
            order_number: row.order_name,
            invoice_type: 1,
            invoice_id: row.id,
        }
        table.value.configs.loading = true
        let res = await InvoiceApi.getInstance().downloadInvoice(param)
        if(!res.code){
            let blob = new Blob([res],{type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${row.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                Message.success(t('base.downloadSuccess'))
            },1500) 
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 重新下载To B发票
    const downloadToBInvoice = async (row)=>{
        let param = {
            order_number: row.order_name,
            invoice_type: 1,
            invoice_child_type: row.invoice_child_type == '-'? '' : row.invoice_child_type,
            invoice_id: row.id,
        }
        table.value.configs.loading = true
        let res = row.invoice_type_val == '1'
                ? await InvoiceApi.getInstance().downloadInvoice(param) 
                : await InvoiceApi.getInstance().downloadPrepaidInvoice(encodeURIComponent(row.prepaid_order_id), {}) 

        if(!res.code){
            let blob = new Blob([res], {type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${row.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                Message.success(t('base.downloadSuccess'))
            },1500) 
            
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 下载无效发票
    const downloadInvaildInvoice = async (row)=>{
        // 红字按发票号命名，其余照旧按订单号
        const fileName = row.invoice_type_val == 2 ? row.invoice_no : row.order_name
        let param = {
            category: 'files',
            file_name: fileName,
            file_no: row.file_no
        }
        Message.success(t('base.exporting'))
        table.value.configs.loading = true
        let res = await InvoiceApi.getInstance().downloadInvaildInvoice(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${fileName}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.downloadSuccess'))
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 重新生成To C发票
    const reGenerateToCInvoice = async (row)=>{
        let param = {
            order_number: row.order_name,
            invoice_date: dateToTimestamp(invoice_date.value) * 1000,
            invoice_type: 1,
        }
        table.value.configs.loading = true
        let res = await InvoiceApi.getInstance().genertaeOrderInvoice(param)
        if(!res.code){
            let blob = new Blob([res],{type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${row.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                getInvoiceList()
                Message.success(t('base.downloadSuccess'))
            },1500) 
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 重新生成To B发票
    const reGenerateToBInvoice = async (row)=>{
        let invoiceDate = dateToTimestamp(invoice_date.value) * 1000
        let param = {
            order_number: row.order_name,
            invoice_date: invoiceDate,
            invoice_type: 1,
            invoice_child_type: row.invoice_child_type == '-'? '' : row.invoice_child_type,
        }
        table.value.configs.loading = true
        let res = row.invoice_type_val == '1'
                ? await InvoiceApi.getInstance().genertaeOrderInvoice(param) 
                : await InvoiceApi.getInstance().rebuildPrepaidInvoice(encodeURIComponent(row.prepaid_order_id), {invoice_date: invoiceDate}) 

        if(!res.code){
            let blob = new Blob([res], {type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${row.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                getInvoiceList()
                Message.success(t('base.downloadSuccess'))
            },1500) 
            reGenerateVisible.value = false
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 发送发票
    const sendInvoice = async (row)=>{
        let invoiceChildType = row.invoice_child_type == '-'? '' : row.invoice_child_type
        Message.success(t('base.sending'))
        row.sendBtnText = t('invoice.sending')
        
        let res = row.invoice_type_val == '1'
                ? await InvoiceApi.getInstance().sendInvoiceToEmail(encodeURIComponent(row.order_name), encodeURIComponent(invoiceChildType))
                : await PrepaidOrderApi.getInstance().sendInvoice(row.prepaid_order_id)
        if(res.code == 0){
           Message.success(t('base.sendSuccess'))
           getInvoiceList()
        }else{
            Message.error(res.msg)
            row.sendBtnText = row.send_sequence == 0? t('invoice.send') : t('invoice.reSend')
        }
    }

    // 失效发票
    const invalidInvoice = async (row)=>{
        let res = await InvoiceApi.getInstance().invalidInvoiceById(row.id)
        if(res.code == 0){
            Message.success(t('base.operateSuccess'))
            getInvoiceList()
        }else{
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content: res.msg,
                okText:t('base.ok'),
                onOk:()=>{}
            })
        }
    }

    // 删除发票
    const deleteInvoice = async (row)=>{
        let res = await InvoiceApi.getInstance().deleteInvoiceById(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            getInvoiceList()
        }else{
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                content: res.msg,
                okText:t('base.ok'),
                onOk:()=>{}
            })
        }
    }

    // 录入付款金额
    const onBeforeOkPayAmount = async ()=>{
        if(payAmount.value === '' || payAmount.value === undefined){
            Message.error(t('invoice.payAmount') + ' ' + t('base.noEmpty'))
            return false
        }

        let param = {
            pay_amount:payAmount.value,
            payment_date: payment_date.value? dateToTimestamp(payment_date.value) : ''
        }
        let res = await InvoiceApi.getInstance().enterPayAmount(param, rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            payAmountVisible.value = false
            getInvoiceList()
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户信息
    const getCustomerInfo = async (row)=>{
        customerInfo_loading.value = true
        let res = await OrderApi.getInstance().getCustomer(row.customer_invoice_id)
        if(res.code == 0){
            customerInfo.value = {
                ...res.data,
                countryCity: !res.data.city? `${res.data.country} / -` : `${res.data.country} / ${res.data.city}`
            }
            customerInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

     // 导出发票列表
     const exportFile = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'create_timestamp'){
                form[i.key] = queryForm.formData[i.key]
            }
        })

        let param = {
            ...form,
            order_name:form.order_name.trim(),
            invoice_child_type:form.invoice_child_type.trim(),
            invoice_no:form.invoice_no.trim(),
            begin_date:!queryForm.formData.create_timestamp? '' : dateToTimestamp(`${queryForm.formData.create_timestamp[0]} 00:00:00`),
            end_date:!queryForm.formData.create_timestamp? '' : dateToTimestamp(`${queryForm.formData.create_timestamp[1]} 23:59:59`),
        }

        // console.log(param,'ppppp')
        Message.success(t('base.exporting'))
        let res = await InvoiceApi.getInstance().exportInvoice(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('invoice.exportInvoiceData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
        }else{  
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 100
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    // ---------- 批量修改发票 ----------
    const resetModify = ()=>{
        modifyFileList.value = []
        modifyResult.value = []
        modifyLoading.value = false
        modifyExporting.value = false
        modifyChecking.value = false
    }

    const modifyUploadChange = (fileItem)=>{
        modifyFileList.value = fileItem.slice(-1)
        // 换了文件, 上一次的结果不再对应当前选择
        modifyResult.value = []
    }

    // 把改前改后压成一行摘要, 完整的 12 列在导出的 Excel 里
    const changeSummary = (record)=>{
        if(record.status == 'SKIPPED' || record.status == 'FAILED'){
            return '-'
        }
        let parts = []
        const diff = (label, oldVal, newVal)=>{
            if(oldVal == newVal) return
            if(oldVal == null && newVal == null) return
            parts.push(`${label}: ${oldVal == null? '-' : oldVal} → ${newVal == null? '-' : newVal}`)
        }
        diff(t('invoice.orderName'), record.old_order_name, record.new_order_name)
        diff(t('invoice.invoiceChildType'), record.old_delivery_number, record.new_delivery_number)
        diff(t('base.date'), (record.old_invoice_date||'').split(' ')[0], (record.new_invoice_date||'').split(' ')[0])
        diff(t('invoice.invoiceAmount'), record.old_invoice_amount, record.new_invoice_amount)
        diff(t('invoice.payAmount2'), record.old_pay_amount, record.new_pay_amount)
        diff(t('invoice.payStatus'), record.old_pay_status, record.new_pay_status)
        if(record.voided_invoice_no){
            parts.push(`${t('invoice.modifyVoided')}: ${record.voided_invoice_no}`)
        }
        return parts.length? parts.join('; ') : t('invoice.modifyNoChange')
    }

    // dryRun 为 true 时后端只校验, 不写库
    const submitModify = async(dryRun)=>{
        if(modifyFileList.value.length == 0){
            Message.error(t('invoice.modifyNoFile'))
            return
        }
        let form = new FormData()
        form.append('file', modifyFileList.value[0].file)

        modifyLoading.value = true
        let res = await InvoiceApi.getInstance().modifyInvoice(form, dryRun)
        modifyLoading.value = false

        if(res.code == 0){
            modifyResult.value = res.data.details
            if(!dryRun){
                Message.success(`${t('invoice.modifySuccess')}: ${res.data.success}/${res.data.total}`)
                getInvoiceList()
            }
        }else{
            Message.error(res.msg)
        }
    }

    const confirmModify = ()=>{
        Modal.warning({
            title: t('base.tip'),
            titleAlign:'start',
            content: t('invoice.modifyConfirmTip'),
            hideCancel:false,
            okText:t('base.ok'),
            cancelText:t('base.cancel'),
            onOk:()=>{
                submitModify(false)
            }
        });
    }

    // 下载检查结果: 后端在用户原文件上追加 Message 列回写, 改完可以直接再传上来
    const exportModifyCheck = async()=>{
        if(modifyFileList.value.length == 0){
            Message.error(t('invoice.modifyNoFile'))
            return
        }
        let form = new FormData()
        form.append('file', modifyFileList.value[0].file)

        modifyChecking.value = true
        let res = await InvoiceApi.getInstance().exportModifyCheck(form)
        modifyChecking.value = false

        if(res && res.code != undefined && res.code != 0){
            Message.error(res.msg)
            return
        }
        downloadBlob(res, 'invoice_modify_check.xlsx')
    }

    const downloadBlob = (res, fileName)=>{
        let blob = new Blob([res])
        let a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.download = fileName
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(a.href)
        document.body.removeChild(a)
        Message.success(t('base.exportSuccess'))
    }

    // 导出完整的改前改后, 留档和回滚用。
    // 直接把页面上这份结果回传给后端渲染, 不能拿原文件重跑 ——
    // 实跑之后数据已经变了, 重跑读到的「改前」其实是改后的值
    const exportModifyResult = async()=>{
        if(modifyResult.value.length == 0){
            Message.error(t('invoice.modifyNoFile'))
            return
        }

        modifyExporting.value = true
        let res = await InvoiceApi.getInstance().exportModifyResult(modifyResult.value)
        modifyExporting.value = false

        if(res && res.code != undefined && res.code != 0){
            Message.error(res.msg)
            return
        }
        downloadBlob(res, 'invoice_modify_result.xlsx')
    }

    // ---------- 批量替换发票附件 ----------
    const resetReplace = ()=>{
        replaceFileList.value = []
        replaceResult.value = []
        replaceLoading.value = false
    }

    const replaceUploadChange = (fileItem)=>{
        replaceFileList.value = fileItem
        // 换了文件, 上一次的结果不再对应当前选择
        replaceResult.value = []
    }

    // dryRun 为 true 时后端只做匹配, 不上传也不写库
    const submitReplace = async(dryRun)=>{
        if(replaceFileList.value.length == 0){
            Message.error(t('invoice.replaceNoFile'))
            return
        }

        let form = new FormData()
        replaceFileList.value.forEach(i=>{
            form.append('files', i.file)
        })

        replaceLoading.value = true
        let res = await InvoiceApi.getInstance().replaceInvoiceAttachment(form, dryRun)
        replaceLoading.value = false

        if(res.code == 0){
            replaceResult.value = res.data.details
            if(!dryRun){
                Message.success(`${t('invoice.replaceSuccess')}: ${res.data.success}/${res.data.total}`)
                getInvoiceList()
            }
        }else{
            Message.error(res.msg)
        }
    }

    const confirmReplace = ()=>{
        Modal.warning({
            title: t('base.tip'),
            titleAlign:'start',
            content: t('invoice.replaceConfirmTip'),
            hideCancel:false,
            okText:t('base.ok'),
            cancelText:t('base.cancel'),
            onOk:()=>{
                submitReplace(false)
            }
        });
    }

    watch(()=>visible2C.value,(val)=>{
        if(!val) getInvoiceList()
    })

    watch(()=>visible2B.value,(val)=>{
        if(!val) getInvoiceList()
    })

    onMounted(()=>{
        queryForm.formData.valid_flag = 0
        if(history.state.fromPage == 'PrepaidOrderList'){
            queryForm.formData.invoice_type = 5
            queryForm.formData.order_name = history.state.order_name
            getInvoiceList()
        }else{
            queryForm.formData.invoice_type = 1
            getInvoiceList()
        }

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })

        is_hepha_customer.value = userInfo.value.role == 16

        queryForm.formField.forEach(i=>{
            if(i.key == 'invoice_type'){
                i.options[1].disabled = is_hepha_customer.value
            }
        })
    })

</script>

<style lang="less" scoped>

.platform_no{
    font-size: 12px;
    color: rgb(var(--gray-6));
    word-break: break-all;
}

.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }

        /deep/ .arco-form-item-layout-inline{
            margin-right: -10px;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

.countBar{
    width: fit-content;
    margin: 0 auto 20px;
    font-size:12px;
    font-weight: 600;
    
    /deep/ .arco-alert{
        padding: 3px 15px !important;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}


/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-picker-size-medium,
/deep/ .arco-select-view-single{
    height: 28px;
}


/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 10px 0;
    font-weight: 600;
}

/deep/ .arco-table-container{
    padding-bottom: 0;
}

/deep/ .arco-table-td{
    // padding: 10px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}


.addForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-picker-size-medium{
        height: 45px;
    }

    /deep/ .arco-form-item-label-col{
        line-height: 45px;
    }
}

.customer_info{
    font-size:13px;
    color: #666;
    padding: 0 10px;
    line-height: 25px;
}

/deep/ .arco-modal-body{
    text-align: center;
}

</style>